import axios from "axios";

let controller;

export async function getProducts(url, query, size, language) {
    if (controller) {
        controller.abort();
    }

    controller = new AbortController();

    const res = await axios
        .post(url, {
            value: query,
            size: size,
            l: language
        }, {
            signal: controller.signal
        });

    return {
        total: res.data.length,
        items: res.data.map((product) => ({
            productId: product.product_id,
            label: product.label,
            url: product.url,
        }))
    }
}